// extracted by mini-css-extract-plugin
export default {"form-wrap-mobile":"JL0ee24ZqO0rjtGk_sxU"};